<template>
  <div class="distributionManage">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="110px"
        :model="formInline"
        inline
      >
        <el-form-item prop="name" label-width="90" label="招生服务方名称">
          <el-input
            clearable
            v-model.trim="formInline.name"
            placeholder="请输入招生服务方名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="contactsName" label="联系人名称">
          <el-input
            clearable
            v-model.trim="formInline.contactsName"
            placeholder="请输入联系人名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="contactsPhone" label="联系人手机号">
          <el-input
            v-model.trim="formInline.contactsPhone"
            maxlength="11"
            placeholder="请输入联系人手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <div class="title" v-if="checkAdmin()">
        <el-button size="small" type="primary" @click="openMenuAdmin">招生服务方菜单管理</el-button>
        <el-button size="small" type="primary" @click="openRolesProfile">招生服务方角色配置</el-button>
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="招生服务方名称" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="checkAdmin()"
          label="所属教务服务方"
          minWidth="160"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.parentName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="logo" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.logo">
              <el-image
                style="width: 60px; height: 60px"
                :src="row.logo"
                :preview-src-list="[row.logo]"
              />
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="渠道来源" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.source || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人姓名" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contactsName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人手机号" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contactsPhone || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合约名称" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.splitContractName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合作状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <template v-if="row.contractValidityStatus === 1">
              <el-tag v-if="row.cooperateState === 1">合作中</el-tag>
              <el-tag type="success" v-else-if="row.cooperateState === 2">合作暂停</el-tag>
            </template>
            <el-tag type="danger" v-else>合作合同待上传</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="当前合同状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.contractValidityStatus === 1">有效期内</el-tag>
            <el-tag type="danger" v-else-if="row.contractValidityStatus === 2">不在有效期内</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lastUpdateDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="最后操作人" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lastUpdateName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="300" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span class="blue_Box" v-if="!checkAdmin()" @click="openSetAdmin(row)">设置管理员</span>
            <span :class="row.contractValidityStatus === 1 ? 'blue_Box' : 'gray_Box'" v-if="row.cooperateState === 1 && checkAdmin()" @click="handleConsociation('2', row.id, row)">暂停合作</span>
            <span :class="row.contractValidityStatus === 1 ? 'blue_Box' : 'gray_Box'" v-else-if="row.cooperateState !== 1 && checkAdmin()" @click="handleConsociation('1', row.id, row)">继续合作</span>
            <span class="blue_Box" @click="openHandleAgency('agency_alter', row)">编辑</span>
            <span class="blue_Box" @click="openHandleSignInfo(row)">签约信息</span>
            <br>
            <span class="blue_Box" @click="openContractAdmin(row)">合同管理</span>
            <span class="blue_Box" @click="openContractList(row)" >分账比例配置</span>
            <span class="blue_Box" @click="openSuretyManage(row)">保证金管理</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <!-- 招生服务方角色配置 -->
    <RolesProfile ref="rolesProfileRef" />
    <!-- 添加、编辑教务服务方 -->
    <HandleAgency ref="handleAgencyRef" />
    <!-- 合同管理 -->
    <ContractAdmin ref="contractAdminRef" type="1" />
    <!-- 签约信息 -->
    <SignInfo ref="signInfoRef" />
    <!-- 菜单管理 -->
    <MenuAdmin ref="menuAdminRef" title="招生服务方菜单管理" />
    <!-- 设置管理员 -->
    <SetAdmin ref="setAdminRef" />
    <!-- 分账比例配置列表 -->
    <ContractList ref="contractListRef" :type="2" @refresh="refresh" />
    <!-- 保证金管理 -->
    <SuretyManage ref="suretyManageRef" />
  </div>
</template>

<script>
import { getSubProxyList, updateCompany } from "@/api/organization";
import SetAdmin from "@/views/organization/components/setAdmin.vue";
import ContractList from "@/views/organization/components/contractList.vue";
import MenuAdmin from "@/views/organization/components/menuAdmin.vue";
import RolesProfile from "@/views/organization/components/rolesProfile.vue";
import HandleAgency from "@/views/organization/components/handleAgency.vue";
import ContractAdmin from "@/views/organization/components/contractAdmin.vue";
import SignInfo from "@/views/organization/components/signInfo.vue";
import SuretyManage from "@/views/organization/components/suretyManage.vue";
import myPagination from "@/components/myPagination.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  name: "DistributionManage",
  components: {
    SetAdmin,
    MenuAdmin,
    myPagination,
    RolesProfile,
    HandleAgency,
    ContractAdmin,
    SignInfo,
    ContractList,
    SuretyManage
  },
  data() {
    return {
      loading: false,
      formInline: {
        name: "",
        contactsName: "",
        contactsPhone: "",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
    };
  },
  mounted() {
    this.getSubProxyList({ page: 1, limit: 10 });
  },
  methods: {
    // 设置管理员
    openSetAdmin(payload) {
      this.$refs.setAdminRef.init(payload.id);
    },
    openMenuAdmin() {
      this.$refs.menuAdminRef.init("distribution");
    },
    // 合同管理
    openContractAdmin(payload) {
      this.$refs.contractAdminRef.init(payload.id);
    },
    // 添加、编辑
    openHandleAgency(status, payload) {
      this.$refs.handleAgencyRef.init(status, payload);
    },
    // 添加、编辑签约信息
    openHandleSignInfo(payload) {
      this.$refs.signInfoRef.init(payload.id);
    },
    // 分账比例设置
    openContractList(payload) {
      this.$refs.contractListRef.init(payload);
    },
    // 保证金管理
    openSuretyManage (payload) {
      this.$refs.suretyManageRef.init(payload)
    },
    // 刷新
    refresh() {
      this.getSubProxyList(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 继续、暂停合作
    handleConsociation(cooperateState, id, payload) {
      if (payload.contractValidityStatus !== 1) {
        return;
      }
      let message = cooperateState === "1" ? "继续" : "暂停";
      this.$confirm(`您确认要${message}合作吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateCompany({ cooperateState, id }).then((res) => {
          if (res.code === 0) {
            this.refresh();
            this.$message({
              type: "success",
              message: `合作已${message}`,
            });
          }
        });
      });
    },
    // 展示、隐藏
    handleShow(displayed, id, payload) {
      if (displayed === "0" && payload.contractValidityStatus !== 1) {
        return;
      }
      let message = displayed === "0" ? "展示" : "隐藏";
      this.$confirm(`您确认要${message}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateCompany({ displayed, id }).then((res) => {
          if (res.code === 0) {
            this.refresh();
            this.$message({
              type: "success",
              message: `${message}成功`,
            });
          }
        });
      });
    },
    openRolesProfile() {
      this.$refs.rolesProfileRef.init("distribution");
    },
    async getSubProxyList(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getSubProxyList({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getSubProxyList(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getSubProxyList({ page: 1, limit: 10 });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getSubProxyList(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getSubProxyList(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.distributionManage {
  .title {
    margin: 0px 0 10px;
  }
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .gray_Box {
    margin: 0 6px;
    color: gray;
    cursor: no-drop;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
